export function isElementInClientRect (element) {
  return element.getBoundingClientRect().top <= window.innerHeight && element.getBoundingClientRect().bottom >= 0
}

export function isElementVisible (element) {
  return getComputedStyle(element).display !== 'none'
}



// WEBPACK FOOTER //
// ./src/shared/elementVisibility.js